import { Snowplow2StatsDataTrackable } from './trackable';
import { StatsDataAgentInterface } from '../../../stats/data/agent.interface';
import { Snowplow2StatsAdapterSchemaSerpResultContext } from '../adapter/schema-serp-result-context';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsAdapterSchemaAgentContext } from '../adapter/schema-agent-context';
import { Snowplow2StatsAdapterSchemaAgentSearchContext } from '../adapter/schema-agent-search-context';
import { Snowplow2StatsAdapterSchemaSearchContext } from '../adapter/schema-search-context';
import { StatsDataBrokerInterface } from '../../../stats/data/broker.interface';
import { Snowplow2StatsAdapterSchemaBrokerContext } from '../adapter/schema-broker-context';
import { Snowplow2StatsAdapterSchemaAttributionContext } from '../adapter/schema-attribution-context';
import { Snowplow2StatsAdapterSchemaAuthContext } from '../adapter/schema-auth-context';

export class Snowplow2StatsDataAgent extends Snowplow2StatsDataTrackable {
  /**
   * @inheritDoc
   */
  constructor(context: StatsContextInterface, rawData: StatsDataAgentInterface) {
    super(context);

    // Generate broker data
    const brokerData: StatsDataBrokerInterface = {
      id: rawData.broker.id,
      name: rawData.broker.name,
      position: rawData.position,
      positionPage: rawData.positionPage,
      isSmartAd: 0, // Hard coded because a broker cannot be smartAd when used in an agent data
      listingStatus: rawData.listingStatus,
    };

    // Agent context
    this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaAgentContext(rawData, context).getData());

    // Broker context
    this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaBrokerContext(brokerData, context).getData());

    // Agent search context (optional)
    if (context.global.agent_search) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaAgentSearchContext(context).getData());
    }

    // Property search context (optional)
    if (context.global.property_search) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaSearchContext(context).getData());
    }

    // Agent SERP or property SERP context (optional)
    if ((context.global.agent_serp || context.global.property_serp) && context.local.pagination) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaSerpResultContext(rawData, context).getData());
    }

    // Authentication context (optional)
    if (context.global.authentication.user) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaAuthContext(context).getData());
    }

    if (context.global.authentication.attributionId) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaAttributionContext(context).getData());
    }

    /**
     * TODO-FE[later]: include twice listing_context in some cases:
     *
     * @url https://github.com/Agentfinder/pfdsa-docs/blob/instrumentation-guide
     * /measurement-guide/implementations/snowplow/1-portal.md#listing_context
     */
  }
}
